import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class BooleanInput extends React.Component {
    state = { checked: true }
    componentWillMount() {
    }

    checkSettings(param) {
        if (this.props.settings) {
            return this.props.settings[param]
        } else {
            return false
        }
    }

    

    render() {
       
        return (
            <div className='mt-1'>
                 <img width={20} src="/images/check2.png"/>
               {/* <p>{this.props.data? this.props.header.information.value:''}</p> */}
            </div>
        );
    }
}

export default BooleanInput;
